/**
 * Workflow GraphQL mutations (7 total).
 */
import { gql } from '@apollo/client';
import { WORKFLOW_FIELDS_FRAGMENT } from './fragments';

export const CREATE_WORKFLOW = gql`
  ${WORKFLOW_FIELDS_FRAGMENT}
  mutation CreateWorkflow($input: GqlCreateWorkflowInput!) {
    createWorkflow(input: $input) {
      ...WorkflowDetailFields
    }
  }
`;

export const UPDATE_WORKFLOW = gql`
  ${WORKFLOW_FIELDS_FRAGMENT}
  mutation UpdateWorkflow(
    $tenantId: String!
    $workflowId: String!
    $input: GqlUpdateWorkflowInput!
  ) {
    updateWorkflow(tenantId: $tenantId, workflowId: $workflowId, input: $input) {
      ...WorkflowDetailFields
    }
  }
`;

export const DELETE_WORKFLOW = gql`
  mutation DeleteWorkflow($tenantId: String!, $workflowId: String!) {
    deleteWorkflow(tenantId: $tenantId, workflowId: $workflowId)
  }
`;

export const ACTIVATE_WORKFLOW = gql`
  ${WORKFLOW_FIELDS_FRAGMENT}
  mutation ActivateWorkflow($tenantId: String!, $workflowId: String!) {
    activateWorkflow(tenantId: $tenantId, workflowId: $workflowId) {
      ...WorkflowDetailFields
    }
  }
`;

export const DEACTIVATE_WORKFLOW = gql`
  ${WORKFLOW_FIELDS_FRAGMENT}
  mutation DeactivateWorkflow($tenantId: String!, $workflowId: String!) {
    deactivateWorkflow(tenantId: $tenantId, workflowId: $workflowId) {
      ...WorkflowDetailFields
    }
  }
`;

export const RECORD_INSTANTIATION = gql`
  ${WORKFLOW_FIELDS_FRAGMENT}
  mutation RecordInstantiation(
    $tenantId: String!
    $workflowId: String!
    $formulaName: String
    $durationSeconds: Int
    $completed: Boolean!
    $errored: Boolean!
  ) {
    recordInstantiation(
      tenantId: $tenantId
      workflowId: $workflowId
      formulaName: $formulaName
      durationSeconds: $durationSeconds
      completed: $completed
      errored: $errored
    ) {
      ...WorkflowDetailFields
    }
  }
`;

export const CLONE_WORKFLOW = gql`
  ${WORKFLOW_FIELDS_FRAGMENT}
  mutation CloneWorkflow(
    $tenantId: String!
    $sourceWorkflowId: String!
    $newVersion: String!
    $createdBy: String!
  ) {
    cloneWorkflow(
      tenantId: $tenantId
      sourceWorkflowId: $sourceWorkflowId
      newVersion: $newVersion
      createdBy: $createdBy
    ) {
      ...WorkflowDetailFields
    }
  }
`;
